import { UploadBundlesDialogValues } from '../components/UploadBundlesDialog';

export namespace UploadBundlesActionsTypes {
  export const START = 'UPLOAD_BUNDLE_START';
}

export interface UploadBundlesStartAction {
  readonly type: typeof UploadBundlesActionsTypes.START;
  readonly data: UploadBundlesDialogValues;
  readonly oauthId: number;
  readonly myContentUrl: string;
}

export function requestUploadBundlesAction(args: Omit<UploadBundlesStartAction, 'type'>): UploadBundlesStartAction {
  return {
    type: UploadBundlesActionsTypes.START,
    ...args
  };
}
